import PropTypes from 'prop-types';
import MojitoCore from 'mojito/core';
import CmsSportCouponImpl from './cms-sport-coupon.js';
import { noop } from 'mojito/utils';
const UIControllerView = MojitoCore.Presentation.UIControllerView;

/**
 * A generic module responsible for rendering CMS sport-specific coupons.
 *
 * @class CmsSportCoupon
 * @extends Mojito.Core.Presentation.UIControllerView
 * @memberof Mojito.Modules
 */

/**
 * `CmsSportCoupon` prop types.
 *
 * @property {string} sportId - The sport id.
 * @property {string} couponId - The coupon id.
 * @property {string} couponName - The name of the coupon.
 * @property {Function} [onDataLoad = () => {}] - A callback function triggered when all child elements have finished loading.
 *
 * @memberof Mojito.Modules.CmsSportCoupon
 */
const propTypes = {
    sportId: PropTypes.string.isRequired,
    couponId: PropTypes.string.isRequired,
    couponName: PropTypes.string.isRequired,
    onDataLoad: PropTypes.func,
};

const defaultProps = {
    onDataLoad: noop,
};

export default UIControllerView('CmsSportCoupon', CmsSportCouponImpl, propTypes, defaultProps);
